import { useEffect, useState } from "react";


export default function useWindow() {
  const [width, setWidth] = useState(0);

  const throttle = (func, delay) => {
    /**
     * Throttles function firing
     * via a set delay (in ms).
     */

    let inProgress = false;
    return (...args) => {
      if (inProgress) {
        return
      }
      inProgress = true;
      setTimeout(() => {
        func(...args)        // Consider moving this line before the set timeout if you want the very first one to be immediate
        inProgress = false
      }, delay)
    }
  }

  useEffect(() => {

    const onResize = throttle(() => {
      setWidth(window.innerWidth);
    }, 1000);
    onResize();
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    }
  }, []);

  return width;
}
